/** Clear the CRM login token from this origin. */
export function clearLoginSession() {
  if (typeof window === 'undefined') return
  window.localStorage.removeItem('doggos_l')
  window.dispatchEvent(new CustomEvent('doggos-auth-logout'))
}

/**
 * End the CRM session and return to the public homepage.
 * Uses a hard navigation so Stream, cached profile state, and JWT refresh
 * do not keep the user signed in (common on Vercel preview / dev URLs).
 */
export function logout() {
  if (typeof window === 'undefined') return
  clearLoginSession()
  window.location.replace(`${window.location.origin}/`)
}
